export default class YoutubeVideoPlayer {
  initialHtmlElement = undefined;
  playerElement = undefined;
  player = undefined;
  videoOptions = {};
  isAlreadyAnIframe = false;

  static loadTheYoutubeIframeApi() {
    const youtubeIframeApiUrl = 'https://www.youtube.com/iframe_api';
    let tag = document.querySelector(`script[src="${youtubeIframeApiUrl}"]`);

    if (tag) {
      return;
    }

    tag = document.createElement('script');
    tag.setAttribute('src', youtubeIframeApiUrl);
    document.body.appendChild(tag);
  }

  constructor(htmlElement, videoOptions = {}, isAlreadyAnIframe = false) {
    // Inspired by https://developers.google.com/youtube/iframe_api_reference?hl=fr

    this.initialHtmlElement = htmlElement;

    const innerPlayer =
      this.initialHtmlElement.querySelector('.youtube-player');

    this.playerElement = innerPlayer ? innerPlayer : this.initialHtmlElement;

    this.videoOptions = videoOptions;
    this.isAlreadyAnIframe = isAlreadyAnIframe;
  }

  load(autoplay = true) {
    if (!window.YT) {
      console.error('Youtube Iframe Api not Loaded yet.');

      return;
    }

    if (
      !this.playerElement ||
      !this.playerElement.dataset.videoId ||
      this.isLoaded()
    ) {
      return;
    }

    const playerOptions = {
      playerVars: {
        autoplay: 0,
        cc_load_policy: 0,
        hl: 'fr',
        iv_load_policy: 3,
        modestbranding: 1,
        rel: 0,
        showinfo: 0,
      },
      events: {
        onReady: (event) => {
          this.initialHtmlElement.classList.add('loaded');

          if (autoplay) {
            event.target.playVideo();
          }
        },
        onError: (event) => {
          console.error(event);
        },
      },
      ...this.videoOptions,
    };

    if (!this.isAlreadyAnIframe) {
      playerOptions.height = '480';
      playerOptions.width = '720';
      playerOptions.videoId = this.playerElement.dataset.videoId;
    }

    this.player = new window.YT.Player(this.playerElement, playerOptions);
  }

  isLoaded() {
    return this.initialHtmlElement.classList.contains('loaded');
  }

  unload() {
    if (
      this.player &&
      this.player.destroy &&
      this.player.destroy instanceof Function
    ) {
      this.player.destroy();
    }
  }

  play() {
    if (
      this.player &&
      this.player.playVideo &&
      this.player.playVideo instanceof Function
    ) {
      this.player.playVideo();
    }
  }

  pause() {
    if (
      this.player &&
      this.player.pauseVideo &&
      this.player.pauseVideo instanceof Function
    ) {
      this.player.pauseVideo();
    }
  }

  stop() {
    if (
      this.player &&
      this.player.stopVideo &&
      this.player.stopVideo instanceof Function
    ) {
      this.player.stopVideo();
    }
  }
}
